import ChecklistThemeSectionComponent, {
  ChecklistThemeSectionComponentProps,
} from './ChecklistThemeSectionComponent';

export default ChecklistThemeSectionComponent;

export type { ChecklistThemeSectionComponentProps };
